export const allowedExportColumns: Record<string, string> = {
  accountNumber: 'Account Number',
  siteName: 'OPU Site',
  donorName: 'Donor Name',
  donorBreed: 'Donor Breed',
  sireName: 'Sire Name',
  sireBreed: 'Sire Breed',
  sireReg: 'Sire Reg',
  semenTypeName: 'Semen Type',
  ivcNumber: 'IVC Num',
  cleaved: 'Cleaved',
  predictedGood: 'Quality',
  predictedVeryLow: 'Low',
  totals: 'Total Embryos',
  origShipped: 'Ship',
  origHeldAtTog: 'Held',
  day5esttrans: 'Day 5 Est Trans',
  exportName: 'Export',
  csrComment: 'CSR Comment',
  colCode: 'Collection Code',
  cane: 'NAAB',
};

export const allowedExportColumnsWithPTA: Record<string, string> = {
  accountNumber: 'Account',
  siteName: 'OPU Site',
  donorName: 'Donor Name',
  donorBreed: 'Donor Breed',
  sireName: 'Sire Name',
  sireBreed: 'Sire Breed',
  semenTypeName: 'Semen Type',
  ivcNumber: 'IVC Num',
  cleaved: 'Cleaved',
  predictedGood: 'Qual',
  predictedVeryLow: 'Low',
  totals: 'Total Embryos',
  origShipped: 'Ship',
  origHeldAtTog: 'Held',
  day5esttrans: 'Estimate',
  exportName: 'Export',
  csrComment: 'Notes',
  colCode: 'Collection Code',
  cane: 'NAAB',
  embryoCalcPaTpi: 'Embryo TPI',
  embryoCalcPaNm: 'Embryo NM',
};
